import * as types from "../constants/ActionTypes";

const interactionsmodal = (state = [], action) => {
  switch (action.type) {
    case "INTERACTIONS_MODAL":
      return {
        type: "INTERACTIONS_MODAL",
        cliente: action.cliente,
        telefone: action.telefone,
        contactid: action.contactid
      };
    default:
      return state;
  }
};

export default interactionsmodal;
